import { render, staticRenderFns } from "./AreaPersonal.vue?vue&type=template&id=fd2543ca&"
import script from "./AreaPersonal.vue?vue&type=script&lang=js&"
export * from "./AreaPersonal.vue?vue&type=script&lang=js&"
import style0 from "./AreaPersonal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VDivider,VTab,VTabs})
